<template>
  <div class="c-white-background">
    <MainNavBarWapV2 :object-data="infoHeader" />
    <div class="container colum top-spacing">
      <h5 class="title text-uppercase m-0 c-body2 text-center">
        {{ $t("deliveryPolicy") }}
      </h5>
      <div class="content mt-10">
        <p class="lh-18 fw-600 ">
          {{ $t("policyObj.text14") }}
        </p>
        <p class="lh-18 ">
          {{ $t("policyObj.text15") }}
        </p>
        <p class="lh-18 ">
          {{ $t("policyObj.text16") }}
        </p>
        <p class="lh-18 ">
          <span class="fw-600"> {{ $t("policyObj.text17") }}</span
          >: {{ $t("policyObj.text18") }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import MainNavBarWapV2 from "@/layout/WapV2/MainNavBar.vue";

export default {
  name: "police-delivery",
  computed: {},
  components: {
    MainNavBarWapV2
  },
  props: {},
  data() {
    return {
      infoHeader: {
        title: this.$t("deliveryPolicy"),
        isShowHomeIcon: true,
        isShowMenu: true
      }
    };
  },
  created() {}
};
</script>
<style scoped>
.top-spacing {
  padding-top: 100px;
}
@media screen and (min-width: 0px) and (max-width: 991px) {
  .top-spacing {
    padding-top: 60px;
  }
}
</style>
